import React, { useEffect, useState, useRef } from "react";
import { useAtom } from "jotai";
import axios from "axios";
import toast from "react-hot-toast";
import { gbState } from "../../../components/shared/GlobalState";
import CardTile from "./CardTile";
import { HiUserGroup, HiSearch, HiX } from "react-icons/hi";

const MemberFamiliesChild = () => {
  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [data, setData] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    let urlLink = `${process.env.REACT_APP_API_URL}/family/${user.church_id}`;
    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        const oldData = response.data.families;
        const filteredFamilies = removeFamily(oldData, user?._id);
        setData(filteredFamilies);
        setFilteredData(filteredFamilies);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  }, []);

  // Remove the users family
  const removeFamily = (data, primaryMemberId) => {
    return data.filter(
      (family) => family?.primary_member_id?._id !== primaryMemberId
    );
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);

    if (!searchValue.trim()) {
      setFilteredData(data);
      return;
    }

    // Filter by family name, email, or phone
    const filtered = data?.filter((family) => {
      const familyName = family.family_name?.toLowerCase() || "";
      const primaryMember = family.primary_member_id || {};
      const email = primaryMember.email?.toLowerCase() || "";
      const phone = primaryMember.phone?.toLowerCase() || "";

      return (
        familyName.includes(searchValue) ||
        email.includes(searchValue) ||
        phone.includes(searchValue)
      );
    });

    setFilteredData(filtered);
  };

  // Clear search input
  const clearSearch = () => {
    setSearchTerm("");
    setFilteredData(data);
  };

  //send request to buddy
  const addBuddyRequest = (requesterId, recipientId) => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/user/send-buddy-request`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { requesterId, recipientId },
    };

    axios(config)
      .then(function (response) {
        toast.success("Request Sent Successfully.");
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "AssetInwardChild", "/asset/add");
        // console.log(error);
      });
  };

  return (
    <div className="flex flex-grow min-h-screen bg-gray-50">
      <div className="w-full px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex flex-col">
          {/* Header Section */}
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold text-gray-900">
                  Church Families
                </h1>
                <p className="mt-2 text-gray-600">
                  Connect with families in our church community
                </p>
              </div>
              <div className="hidden sm:block">
                <div className="p-3 bg-white shadow-sm rounded-xl">
                  <div className="flex items-center space-x-2">
                    <HiUserGroup className="w-5 h-5 text-indigo-500" />
                    <span className="text-sm font-medium text-gray-600">
                      {filteredData?.length || 0} Families
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Search Bar */}
            <div className="relative mt-6">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <HiSearch className="w-5 h-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder="Search by family name, email or phone..."
                  className="block w-full py-2 pl-10 pr-10 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
                {searchTerm && (
                  <button
                    onClick={clearSearch}
                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                    aria-label="Clear search"
                  >
                    <HiX className="w-5 h-5" />
                  </button>
                )}
              </div>
            </div>

            <div className="w-32 h-1 mt-4 bg-indigo-500 rounded-full"></div>
          </div>

          {/* Family Cards */}
          {filteredData && (
            <CardTile
              familiesData={filteredData}
              user={user}
              addBuddyRequest={addBuddyRequest}
              buddies={user?.buddies || []}
            />
          )}

          {/* Empty State */}
          {(!filteredData || filteredData.length === 0) && (
            <div className="flex flex-col items-center justify-center p-8 bg-white shadow-sm rounded-xl">
              <HiUserGroup className="w-16 h-16 text-gray-300" />
              <h3 className="mt-4 text-lg font-semibold text-gray-900">
                No Families Found
              </h3>
              <p className="mt-1 text-gray-500">
                {searchTerm
                  ? "No families match your search criteria."
                  : "There are no families to display at the moment."}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberFamiliesChild;
